import { userActionTypes } from '../actions/types';
import { getStoredUser, storeUser } from '../utils/authStorage';

let user = getStoredUser();
const initialState = user
  ? {
      loggedIn: true,
      user,
      pendingRefreshingToken: null,
      tokenIsValid: null,
      authenticated: false,
    }
  : {
      loggedIn: false,
      user: null,
      pendingRefreshingToken: null,
      tokenIsValid: null,
      authenticated: false,
    };

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userActionTypes.LOGIN_REQUEST:
      return {
        ...state,
        loggingIn: true,
        user: action.user,
        error: null,
      };
    case userActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        loggingIn: false,
        user: action.user,
      };
    case userActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        loggingIn: false,
        loggedIn: false,
        loggingOut: false,
        error: action.error,
      };
    case userActionTypes.LOGOUT_REQUEST:
      return {
        ...state,
        loggingOut: true,
      };
    case userActionTypes.LOGOUT:
      return {
        ...state,
        error: null,
        user: null,
        loggedIn: false,
        loggingOut: false,
      };
    case userActionTypes.REFRESHING_TOKEN:
      return {
        ...state,
        pendingRefreshingToken: true,
        tokenIsValid: false,
      };
    case userActionTypes.TOKEN_REFRESHED:
      return {
        ...state,
        pendingRefreshingToken: null,
        tokenIsValid: true,
        user: {
          ...state.user,
          authToken: action.authToken,
        },
      };
    case userActionTypes.UPDATE_USER: {
      const user = { ...state.user, ...action.user };
      storeUser(user);
      return {
        ...state,
        user,
      };
    }
    case userActionTypes.AUTHENTICAT_REQUEST:
      return {
        ...state,
        authState: 'authenticating',
        error: null,
      };
    case userActionTypes.AUTHENTICAT_SUCCESS:
      return {
        ...state,
        authState: 'authenticated',
      };
    case userActionTypes.AUTHENTICAT_FAILURE:
      return {
        ...state,
        authState: 'failed',
        error: action.error,
      };
    case userActionTypes.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPasswordState: 'request',
        error: null,
      };
    case userActionTypes.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordState: 'success',
      };
    case userActionTypes.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPasswordState: 'failure',
        error: action.error,
      };
    case userActionTypes.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordState: 'request',
        error: null,
      };
    case userActionTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordState: 'success',
      };
    case userActionTypes.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPasswordState: 'failure',
        error: action.error,
      };
    default:
      return state;
  }
}
